'use strict';
var address = require('./checkout/address'),
	formPrepare = require('./checkout/formPrepare'),
	loqate = require('../loqate');

/**
 * @function
 * @description Init address book events
 */
exports.init = function () {
	loqate.init($('#billingAddressForm'));
	address.dynamicAddressFieldsHandler($('#billingAddressForm'));
	formPrepare.init({
		continueSelector: '[name$="_address_create"]',
		formSelector: '#billingAddressForm',
		replaceInvalidInput: true,
		autofillValidate: true,
		keyup: false
	});
};
